export function buildLeadsPageURL() {
  return '/leads'
}
